import { Box, styled, TextField } from "@mui/material";

export const TableCellRoot = styled("td")({
	flexDirection: "column",
	width: "100%",
	height: "auto !important",
	paddingLeft: "6px",
	verticalAlign: "top",
});

export const ActionColumn = styled(Box)(() => ({
	margin: "auto",
	display: "flex",
	flexDirection: "row",
	justifyContent: "center",
}));

export const CustomTableTextArea = styled(TextField)(({ theme }) => ({
	width: "100%",
	minHeight: "17px",

	"& .MuiInputBase-input": {
		fontSize: 11,
		height: "100%", // важно для обёртки input
		lineHeight: 1.42,
		paddingTop: "1px",
		padding: "0 !important",
		margin: "0 !important",
		width: "100%",
	},

	"& .MuiInputAdornment-root": {
		marginLeft: "auto",
	},

	"& .MuiInputBase-root": {
		padding: "3px 6px",
	},

	"& .MuiOutlinedInput-root": {
		display: "block",
	},

	"& .MuiInputBase-inputMultiline": {
		minHeight: "18px !important",

		paddingTop: 0,
		paddingBottom: 0,
	},

	"& .MuiInputAdornment-positionEnd": {
		marginRight: "14px",
	},

	"& .MuiInputLabel-root": {
		padding: 0,

		transform: "translate(14px, 8px) scale(1)",
		fontSize: "13px",
	},

	"& .MuiInputLabel-shrink": {
		padding: "0 10px 0 0",
		transform: "translate(14px, -7px) scale(0.8)", // позиция при фокусе
	},

	"& .MuiOutlinedInput-notchedOutline": {
		"& legend": {
			width: "auto !important",
			"& span": {
				display: "inline-block",
				background: theme.palette.background.paper,
				fontSize: "10.5px",
				lineHeight: "1.2",
			},
		},
	},

	".Mui-focused .MuiOutlinedInput-notchedOutline": {
		border: `1px solid ${theme.palette.primary.main}`,
		borderRadius: "3px",
		backgroundColor: "rgba(0, 0, 0, 0.07)",
		padding: 0,
	},

	"& .MuiInputBase-input.MuiAutocomplete-input": {
		padding: "0 0 0 5px!important", // убираем padding
		fontSize: "11.5px",
		margin: "0",
		height: "20px",
		width: "60%",
	},
}));
